import DetailItemList, { DetailItemListProps } from './DetailItemList';

export type { DetailItemListProps };
export default DetailItemList;
